export default {
  locale: 'uk_UA',
  site_name: 'Avtoprod.ua',
  type: 'article',
};
